// Instant search and filtering for the activation error-code library (sections/error-code-lookup.liquid).
(() => {
  if (customElements.get('error-code-lookup')) return;

  // Turkish-aware lowercasing that also folds dotless ı, so "WINDOWS" and "lisanssiz" still match.
  const fold = (value) => value.toLocaleLowerCase('tr-TR').replace(/ı/g, 'i');
  const normalizeCode = (value) => fold(value).replace(/\s+/g, '').replace(/^0x/, '');
  const normalizeText = (value) => fold(value).replace(/\s+/g, ' ').trim();

  // Searchable text of an item: code, title and the cause/solution copy, without labels and buttons.
  const searchableText = (element) => {
    const clone = element.cloneNode(true);
    clone.querySelectorAll('.error-lookup__label, .error-lookup__actions').forEach((node) => node.remove());
    return clone.textContent;
  };

  const askAssistant = (question) => {
    document.dispatchEvent(new CustomEvent('keysofti:ask-ai', { detail: { question } }));
  };

  class ErrorCodeLookup extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-error-search]');
      this.status = this.querySelector('[data-error-status]');
      this.empty = this.querySelector('[data-error-empty]');
      this.filter = 'all';
      this.items = [...this.querySelectorAll('[data-error-item]')].map((element) => ({
        element,
        product: element.dataset.product,
        code: normalizeCode(element.querySelector('.error-lookup__code')?.textContent || ''),
        text: normalizeText(searchableText(element)),
      }));

      this.input.addEventListener('input', () => this.update());
      this.querySelectorAll('[data-filter]').forEach((button) => {
        button.addEventListener('click', () => this.setFilter(button));
      });
      this.addEventListener('click', (event) => this.handleAskAi(event));

      const query = new URLSearchParams(window.location.search).get('q');
      if (query) this.input.value = query.slice(0, 80);
      this.update();
      this.openFromHash();
      window.addEventListener('hashchange', () => this.openFromHash());
    }

    setFilter(activeButton) {
      this.filter = activeButton.dataset.filter;
      this.querySelectorAll('[data-filter]').forEach((button) => {
        const isActive = button === activeButton;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
      this.update();
    }

    update() {
      const rawQuery = this.input.value.trim();
      const codeQuery = normalizeCode(rawQuery);
      const textQuery = normalizeText(rawQuery);
      const matches = this.items.filter((item) => {
        const productMatches = this.filter === 'all' || item.product === this.filter;
        const queryMatches = !rawQuery || item.code.includes(codeQuery) || item.text.includes(textQuery);
        item.element.hidden = !(productMatches && queryMatches);
        return !item.element.hidden;
      });

      if (rawQuery && matches.length === 1) matches[0].element.open = true;
      this.empty.hidden = matches.length > 0;
      this.status.textContent = rawQuery ? `${matches.length} sonuç bulundu` : '';
      this.updateEmptyLinks(rawQuery);
    }

    updateEmptyLinks(rawQuery) {
      const whatsapp = this.empty.querySelector('[data-whatsapp-base]');
      if (!whatsapp) return;
      const message = rawQuery ? `Merhaba, ${rawQuery} hatası alıyorum. Yardımcı olabilir misiniz?` : 'Merhaba, lisans etkinleştirme konusunda yardım istiyorum.';
      whatsapp.href = `${whatsapp.dataset.whatsappBase}?text=${encodeURIComponent(message)}`;
    }

    // Buttons with data-ask-ai are handled globally by ai-assistant.js; only the search-based one is built here.
    handleAskAi(event) {
      if (event.target.closest('[data-ask-ai-search]')) {
        const query = this.input.value.trim();
        askAssistant(query ? `${query} hatasını nasıl çözerim?` : 'Lisans etkinleştirme hatası alıyorum, yardımcı olur musun?');
      }
    }

    openFromHash() {
      let id;
      try {
        id = decodeURIComponent(window.location.hash.slice(1));
      } catch (error) {
        return;
      }
      if (!id) return;
      const target = this.items.find((item) => item.element.id === id);
      if (!target) return;
      if (target.element.hidden) {
        this.input.value = '';
        this.update();
      }
      target.element.open = true;
      target.element.scrollIntoView({ block: 'start' });
    }
  }

  customElements.define('error-code-lookup', ErrorCodeLookup);
})();
